import React from "react";

export default function ChevronRightRounded({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      className={className}
    >
      <circle
        id="Ellipse_20"
        data-name="Ellipse 20"
        cx="15.5"
        cy="15.5"
        r="15.5"
        transform="translate(0.45 0.45)"
        fill="rgba(255,255,255,0)"
        stroke={"currentColor"}
        strokeWidth="1"
      />
      <path
        id="Path_473"
        data-name="Path 473"
        d="M1539.814-463.671h12v-12"
        transform="translate(-748.884 1440.913) rotate(-45)"
        fill="rgba(255,255,255,0)"
        stroke={"currentColor"}
        strokeWidth="1"
      />
    </svg>
  );
}
